<a [routerLink]="['/trusts', this.entityId]">
  <app-entity-name-number-record
    class="trust-name-abn" [name]="name"
    [numberFormatted]="abn | abn"
  />
</a>
